/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_SuccessInputs */

const en_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has been activated successfully.`)
};

const fr_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement a été activé avec succès.`)
};

const de_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement wurde erfolgreich aktiviert.`)
};

const it_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento è stato attivato con successo.`)
};

const ru_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка успешно активирована.`)
};

const es_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su suscripción ha sido activada exitosamente`)
};

const zh_cn2_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的订阅已成功激活。`)
};

const ja_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションが正常に有効化されました。`)
};

const hi_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी सदस्यता सफलतापूर्वक सक्रिय हो गई है।`)
};

const pt_pt2_activate_success = /** @type {(inputs: Activate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura foi ativada com sucesso.`)
};

/**
* | output |
* | --- |
* | "Your subscription has been activated successfully." |
*
* @param {Activate_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_success = /** @type {((inputs?: Activate_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_activate_success(inputs)
	if (locale === "de") return de_activate_success(inputs)
	if (locale === "it") return it_activate_success(inputs)
	if (locale === "ru") return ru_activate_success(inputs)
	if (locale === "es") return es_activate_success(inputs)
	if (locale === "zh-CN") return zh_cn2_activate_success(inputs)
	if (locale === "ja") return ja_activate_success(inputs)
	if (locale === "hi") return hi_activate_success(inputs)
	if (locale === "pt-PT") return pt_pt2_activate_success(inputs)
	return en_activate_success(inputs)
});